const SIGNATURE = "_ammolite" as const;

const ID = "id" as const;

const VA = "variable" as const;

const FN = "function" as const;

const ARGS = "arguments" as const;

export { ARGS, FN, ID, SIGNATURE, VA };
